import React from "react";
import { createTheme, IconButton, InputAdornment, ThemeProvider } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close"

const theme = createTheme(
  /**
   * @see https://material-ui.com/customization/themes/#theme-configuration-variables
   */
  {
    // direction: "rtl",
    typography: {
      fontFamily: ["Poppins"].join(",")
    },

    palette: {
      primary: {
        // light: will be calculated from palette.primary.main,
        main: "#17c191",
        // dark: will be calculated from palette.primary.main,
        // contrastText: "#fff" //will be calculated to contrast with palette.primary.main
      },
      secondary: {
        // light: will be calculated from palette.primary.main,
        main: "#3783e7",
        // dark: will be calculated from palette.primary.main,
        // contrastText: "#fff" //will be calculated to contrast with palette.primary.main
      },
      error: {
        // light: will be calculated from palette.primary.main,
        main: "#f018a6",
        // dark: will be calculated from palette.primary.main,
        // contrastText: "#fff" //will be calculated to contrast with palette.primary.main
      }
    },

    /**
     * @see https://material-ui.com/customization/globals/#default-props
     */
    props: {
      // Name of the component ⚛️
      MuiButtonBase: {
        // The properties to apply
        disableRipple: false, // No more ripple, on the whole application 💣!
      },
      // Set default elevation to 1 for popovers.
      MuiPopover: {
        elevation: 1
      }
    },
    // components: {
    //   MuiTextField: {
    //     defaultProps: {
    //       autoComplete: "off"
    //     }
    //   },
    // }
    components: {
      MuiTextField: {
        defaultProps: {
          InputProps: {
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  type="button"
                  onClick={(e) => {
                    const input = e.currentTarget.closest(".MuiInputBase-root").querySelector("input") ?? e.currentTarget.closest(".MuiInputBase-root").querySelector("textarea");
                    if (input?.disabled) return
                    if (input) input.value = null;
                    const ev = new Event("input", { bubbles: true });
                    input.dispatchEvent(ev);
                  }}
                  size="small"
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            )
          },
          onKeyDown: (e) => {
            if (e.key === "Escape") {
              const input = e.target;
              if (input?.disabled) return
              if (input) input.value = null;
              const ev = new Event("input", { bubbles: true });
              input.dispatchEvent(ev);
              e.stopPropagation()
            }
          }
        },
        styleOverrides: {
          root: {
            "&>.MuiInputBase-root>.MuiSvgIcon-root": {
              display: "none"
            },
            "& .MuiInputBase-input": {
              paddingLeft: "0 !important"
            },
            "& input[type=search]::-webkit-search-cancel-button": {
              WebkitAppearance: "none",
              appearance: "none",
              display: "none"
            },
            "& input[type=search]::-webkit-search-decoration": {
              display: "none"
            },
            "& input[type=search]::-webkit-search-results-button": {
              display: "none"
            },
            "& input[type=search]::-webkit-search-results-decoration": {
              display: "none"
            },
            "& .MuiInputBase-root": {
              paddingRight: 0
            },
            "& .MuiSelect-select": {
              paddingRight: "14px !important"
            }
          }
        }
      },
    }
  }
);

export function MaterialThemeProvider(props) {
  const { children } = props;

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
